import { Card } from '@sm/wds-react';
import { LogoWithText } from '@sm/webassets';
import React from 'react';
import './captive-window.scss';
import Footer from './Footer';

export interface CaptiveWindowProps {}

const CaptiveWindow: React.FC<CaptiveWindowProps> = props => (
  <div className="sm-captive-window__page wds-flex wds-flex--y wds-flex--x-center">
    <div className="sm-captive-window__section">
      <header className="sm-logo__header">
        <LogoWithText />
      </header>

      <Card {...props} />
    </div>
    <div className="sm-captive-window__section">
      <Footer />
    </div>
  </div>
);

export default CaptiveWindow;
